<template>
    <div class="container login-container">

        <div class="d-flex justify-content-center align-items-center flex-column login-page-main-wrapper"
            v-if="landing == true">
            <div class="row justify-content-center login-form-wrapper">
                <div class="col-md-7 login-right d-flex align-items-center rounded-right">
                    <div class="users-style ">

                        <p class="text-center mb-0 login-title"><span class="green-text">LOG IN</span></p>
                        <p class="text-center mb-0 login-intro">to your account</p>

                        <div v-if="showoverlay == false">
                            <div class="clearfix">
                                <div class="mt-4" style="position: relative;">
                                    <b-form @submit.stop.prevent="onSubmit" ref="form">

                                        <b-form-group id="email-group" label="Email / Phone Number" label-for="email">
                                            <b-form-input id="email" name="email" placeholder="" v-model="fdata.email"
                                                v-validate="{ required: true,  }"
                                                :state="validateState('email')" aria-describedby="email-feedback"
                                                data-vv-as="Email"></b-form-input>
                                            <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email')
                                                }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group id="password-group" label="Password" label-for="password">
                                            <b-form-input id="password" name="password" placeholder="" type="password"
                                                v-model="fdata.password" v-validate="{ required: true, min: 8 }"
                                                :state="validateState('password')" aria-describedby="password-feedback"
                                                data-vv-as="Password"></b-form-input>
                                            <b-form-invalid-feedback id="password-feedback">{{
                                                veeErrors.first('password') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <div class="signup-link-container clearfix ">
                                            <div class="">
                                                <b-form-checkbox id="rememberme" class="float-left mt-0 ml-1 d-none"
                                                    v-model="rememberme" name="rememberme" value="1"
                                                    unchecked-value="0">
                                                    Remember Me
                                                </b-form-checkbox>

                                                <a class="btn btn-link float-right forget-pass-link mt-0 p-0"
                                                    href="password/reset">
                                                    Forgot Your Password?
                                                </a>
                                            </div>
                                        </div>
                                        <b-form-group id="login-submit-group">
                                            <b-button id="lg" class="login-form-submit-btn" ref="submit" type="submit"
                                                variant="primary">Login<b-icon icon="chevron-right"
                                                    class="ml-2"></b-icon></b-button>
                                        </b-form-group>

                                        <p class="pt-5 mt-5" style="font-size: 12px; color: rgba(0, 28, 56, 1);">Don’t
                                            have an account? <a class="back-to-login"
                                                :href="$api_url + '/employee/register'"
                                                style="font-size: 12px; color: rgba(0, 28, 56, 1); font-weight: 600;">Register
                                                here</a></p>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                        <div class='login_load' v-else>
                            <div class="trz_loader">
                                Signing In ...
                                <br />
                                <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo text-center"
                                    width="100px" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 login-left d-flex align-items-center position-relative">
                    <img v-bind:src="$api_url + '/images/landing-page/Abstract-Background.png'"
                        class="login-landing-image lgn-mgt" v-if="step == 0">
                    <img v-bind:src="$api_url + '/images/landing-page/Abstract-Background.png'"
                        class="login-landing-image lgn-emp" v-else>
                    <div class="login-left-content-wrapper">
                        <div class="accord-link text-right"><a class='atl-hr-link font-semi-bold'
                                href="https://accordhrm.com/" target="_blank">www.accordhrm.com</a></div>
                        <div class="accord-branding-wrapper text-right">
                            <p>Welcome to</p>
                            <img :src="$api_url + '/images/landing-page/logo-white.png'" class="bkash-landing-image">
                        </div>
                        <p class="landing-page-intro-text">HR & Payroll solutions to suit your business</p>
                        <div class="row">
                            <div class="col-md-7">
                                <p class="d-block"><a href="tel:+880-1711-314600"><b-icon icon="telephone-fill"
                                            class="mr-1"></b-icon><span class="font-light">+880-1711-314600</span></a>
                                </p>
                                <p><a href="mailto:info@accordhrm.com"><b-icon icon="envelope-fill"
                                            class="mr-1"></b-icon><span class="font-light">info@accordhrm.com</span></a>
                                </p>
                            </div>
                            <div class="col-md-5 d-flex align-items-center justify-content-end">
                                <ul class="p-0 m-0 footer-social-icons">
                                    <li class="mr-2"><a target="_blank" href="https://www.facebook.com/accordhrm"><img
                                                :src="$api_url + '/images/landing-page/landing-Facebook.png'"
                                                class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank"
                                            href="https://www.linkedin.com/company/accordhrm/"><img
                                                :src="$api_url + '/images/landing-page/landing-Linkedin.png'"
                                                class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank"
                                            href="https://www.youtube.com/@accordhrm"><b-icon
                                                icon="youtube"></b-icon></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal id="show_terms" size="lg" hide-footer title="End User Terms of Use" scrollable>
                <terms></terms>

                <div class="">
                    <div class="d-flex justify-content-center">
                        <b-form-checkbox v-model="accept" value="true" unchecked-value="false">
                            I accept the terms and use conditions
                        </b-form-checkbox>
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                        <b-form-group id="login-submit-group">
                            <b-button :disabled="!accept" type="button" variant="primary" class=""
                                @click="fakesubmission">Agree & Proceed</b-button>
                        </b-form-group>
                    </div>
                </div>

            </b-modal>

            <!-- footer for mobile -->
            <div class="d-md-none footer-width">
                <div class="footer-mobile-info-main">
                    <p class="footer-mobile-info ">
                        <a class="text-dark" href="tel:+880-1711-314600">
                            <b-icon icon="telephone-fill" class="mr-1"></b-icon>
                            <span class="font-light">+880-1711-314600</span>
                        </a>
                    </p>

                    <p class="footer-email-info">
                        <a class="text-dark" href="mailto:info@accordhrm.com">
                            <b-icon icon="envelope-fill" class="mr-1"></b-icon>
                            <span class="font-light">info@accordhrm.com</span>
                        </a>
                    </p>
                </div>
                <a class='footer-company text-center' href="https://accordhrm.com/"
                    target="_blank">www.accordhrm.com</a>

                <div class=" footer-social-icon">
                    <ul class="p-0 m-0 footer-social-icons">
                        <li class="mr-2">
                            <a target="_blank" href="https://www.facebook.com/accordhrm">
                                <b-icon icon="facebook"></b-icon>
                            </a>
                        </li>
                        <li class="mr-2">
                            <a target="_blank" href="https://www.linkedin.com/company/accordhrm/">
                                <b-icon icon="linkedin"></b-icon>
                            </a>
                        </li>
                        <li class="mr-2">
                            <a target="_blank" href="https://www.youtube.com/@atlhr-smarterhr9465">
                                <b-icon icon="youtube"></b-icon>
                            </a>
                        </li>
                    </ul>

                </div>

            </div>

            <b-modal id="show_change_notice" size="lg" hide-footer title="Our Brand is Evolving" scrollable>
                <div class="">
                    Message goes here.
                </div>
            </b-modal>
        </div>

        <div class="d-flex justify-content-center align-items-center flex-column login-page-main-wrapper" v-else>
            <div class="row justify-content-center login-form-wrapper">
                <div class="col-md-7 login-right d-flex align-items-center rounded-right">

                    <div class="row mb-3 align-items-center">
                        <div class="col-md-12 text-center mb-5">
                            <p class="text-center mb-0 login-title"><span class="green-text">CHOOSE</span></p>
                            <p class="text-center mb-0 login-intro">your preferred Portal</p>
                        </div>

                        <div class="col-md-12 text-center">

                            <b-tabs pills content-class="" nav-class="login-tabs-nav-new mt-5" nav-wrapper-class=""
                                v-model="step">
                                <b-tab @click="resetvalidator('mgt'); selectPortal('mgt');" title-link-class="mgt-tab">
                                    <template v-slot:title><img
                                            v-bind:src="$api_url + '/images/landing-page/fa-mgt.png'"
                                            class="vsm--icon leftmenu mr-2 mgt-active" width="20px" /><img
                                            v-bind:src="$api_url + '/images/fa-mgt.png'"
                                            class="vsm--icon leftmenu mr-2 mgt-not-active" width="20px" />Management
                                        login</template>

                                </b-tab>
                                <b-tab @click="resetvalidator('emp'); selectPortal('emp');" title-link-class="emp-tab">
                                    <template v-slot:title><b-icon icon="person-fill"
                                            class="mr-2"></b-icon>Employee login</template>

                                </b-tab>
                            </b-tabs>
                        </div>

                        <div class="col-md-12 text-center mt-5">
                            Remember my Choice <toggle-button class="ml-2"
                                v-model="remember"
                                :color="{ checked: '#01524b', unchecked: '#e3342f', disabled: '#CCCCCC' }" />
                        </div>
                    </div>

                </div>
                <div class="col-md-6 login-left d-flex align-items-center position-relative">
                    <img v-bind:src="$api_url + '/images/landing-page/Abstract-Background.png'"
                        class="login-landing-image lgn-mgt" v-if="step == 0">
                    <img v-bind:src="$api_url + '/images/landing-page/Abstract-Background.png'"
                        class="login-landing-image lgn-emp" v-else>
                    <div class="login-left-content-wrapper">
                        <div class="accord-link text-right"><a class='atl-hr-link font-semi-bold'
                                href="https://accordhrm.com/" target="_blank">www.accordhrm.com</a></div>
                        <div class="accord-branding-wrapper text-right">
                            <p>Welcome to</p>
                            <img :src="$api_url + '/images/landing-page/logo-white.png'" class="bkash-landing-image">
                        </div>
                        <p class="landing-page-intro-text">HR & Payroll solutions to suit your business</p>
                        <div class="row">
                            <div class="col-md-7">
                                <p class="d-block"><a href="tel:+880-1711-314600"><b-icon icon="telephone-fill"
                                            class="mr-1"></b-icon><span class="font-light">+880-1711-314600</span></a>
                                </p>
                                <p><a href="mailto:info@accordhrm.com"><b-icon icon="envelope-fill"
                                            class="mr-1"></b-icon><span class="font-light">info@accordhrm.com</span></a>
                                </p>
                            </div>
                            <div class="col-md-5 d-flex align-items-center justify-content-end">
                                <ul class="p-0 m-0 footer-social-icons">
                                    <li class="mr-2"><a target="_blank" href="https://www.facebook.com/accordhrm"><img
                                                :src="$api_url + '/images/landing-page/landing-Facebook.png'"
                                                class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank"
                                            href="https://www.linkedin.com/company/accordhrm/"><img
                                                :src="$api_url + '/images/landing-page/landing-Linkedin.png'"
                                                class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank"
                                            href="https://www.youtube.com/@accordhrm"><b-icon
                                                icon="youtube"></b-icon></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- footer for mobile -->
            <div class="d-md-none footer-width">
                <div class="footer-mobile-info-main">
                    <p class="footer-mobile-info ">
                        <a class="text-dark" href="tel:+880-1711-314600">
                            <b-icon icon="telephone-fill" class="mr-1"></b-icon>
                            <span class="font-light">+880-1711-314600</span>
                        </a>
                    </p>

                    <p class="footer-email-info">
                        <a class="text-dark" href="mailto:info@accordhrm.com">
                            <b-icon icon="envelope-fill" class="mr-1"></b-icon>
                            <span class="font-light">info@accordhrm.com</span>
                        </a>
                    </p>
                </div>
                <a class='footer-company text-center' href="https://accordhrm.com/"
                    target="_blank">www.accordhrm.com</a>

                <div class=" footer-social-icon">
                    <ul class="p-0 m-0 footer-social-icons">
                        <li class="mr-2">
                            <a target="_blank" href="https://www.facebook.com/accordhrm">
                                <b-icon icon="facebook"></b-icon>
                            </a>
                        </li>
                        <li class="mr-2">
                            <a target="_blank" href="https://www.linkedin.com/company/accordhrm/">
                                <b-icon icon="linkedin"></b-icon>
                            </a>
                        </li>
                        <li class="mr-2">
                            <a target="_blank" href="https://www.youtube.com/@atlhr-smarterhr9465">
                                <b-icon icon="youtube"></b-icon>
                            </a>
                        </li>
                    </ul>

                </div>

            </div>
        </div>
    </div>

</template>

<script>
import LoginEmployee from './LoginEmployee';
export default {
    props: ['logged'],

    mounted() {
    },
    props: [],
    components: {
        LoginEmployee
    },
    data() {

        return {

            successmsg: '',
            errormsg: [],
            showoverlay: false,
            fdata: { email: null, password: null, agree: 0 },

            rememberme: 1,
            remember: 0,

            accept: false,
            landing: (this.logged != 1),
            landing_emp: false,
            showPassword: false,
            step: 0,
            hostname: window.location.hostname,
            landing_redirect: false,


        }
    },
    methods: {

       

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetvalidator(name) {
            this.$validator.reset();
            let login_wrapper = document.getElementById('loginContainer');
            if (login_wrapper) {
                if (name == 'emp') {
                    login_wrapper.classList.remove('login-mgt-wrapper-animation');
                    login_wrapper.classList.add('login-emp-wrapper-animation');
                } else {
                    login_wrapper.classList.remove('login-emp-wrapper-animation');
                    login_wrapper.classList.add('login-mgt-wrapper-animation');
                }
            }
        },
        selectPortal(type) {
            this.showoverlay = true;
            let url = type === 'emp' ? '/login/employee' : '/login/company';
            let currentObj = this;
            axios.post(this.$api_url + url, { remember: this.remember ? 1 : 0 })
                .then(function (response) {
                    if (response.data.status == 1) {
                        let targetUrl = response.data.redirect;
                        if (!targetUrl) {
                            targetUrl = type === 'emp' ? '/' : '/home';
                        }
                        if (!targetUrl.startsWith('http://') && !targetUrl.startsWith('https://')) {
                            targetUrl = currentObj.$api_url + targetUrl;
                        }
                        window.location.href = targetUrl;
                    } else if (response.data.status == 5) {
                        currentObj.showoverlay = false;
                        currentObj.$bvToast.toast('Session error. Please try logging in again.', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    } else {
                        currentObj.showoverlay = false;
                        currentObj.$bvToast.toast(response.data.message || 'Error logging in.', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    }
                })
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.$bvToast.toast('Login failed. Please try again.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                });
        },
        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        resetForm() {
            this.fdata = {

                //asd:null,
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        fakesubmission: function () {
            this.fdata.agree = 1;
            document.getElementById('lg').click();
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            let formData = new FormData();

            if (this.validateEmail(this.fdata.email)) {
                formData.append('f', 1);
            }
            else if (isNaN(this.fdata.email) === false) {
                
                formData.append('f', 0);
            }
            else {
                alert('Wrong Email/Phone number');
                return false;
            }

            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;


                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                }

                formData.append('rememberme', this.rememberme);
                formData.append('remember', this.remember);

                this.$cookies.set("rememberme", this.rememberme);
                this.showoverlay = true;
                axios.post(this.$api_url + '/login', formData)
                    .then(function (response) {
                        if(response.data === 1) {
                            currentObj.landing = false;
                            return;
                        }
                        if (response.data.status == 1) {
                            let targetUrl = response.data.redirect || '/home';
                            if (!targetUrl.startsWith('http://') && !targetUrl.startsWith('https://')) {
                                targetUrl = currentObj.$api_url + targetUrl;
                            }
                            window.location.href = targetUrl;
                        }
                        else if (response.data.status == 2 || response.data.status == 4) {
                            this.$bvModal.show('show_terms');
                            currentObj.showoverlay = false;
                        }
                        else if (response.data.status == 5) {
                            currentObj.showoverlay = false;
                            currentObj.$bvToast.toast('Duplicate user session. Please get logged out from other device and try again.', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });

                            setTimeout(function () {
                                window.location.reload()
                            }, 2000);
                        }
                        else {
                            currentObj.showoverlay = false;
                            currentObj.$bvToast.toast('You are not authorized to access this.', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });

                        }

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay = false;
                        currentObj.$bvToast.toast('These credentials do not match our records.', {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        });
                    });
            });
        },

    },
    created: function () {
        //
        if (this.$cookies.isKey("rememberme")) {
            if (this.$cookies.get("rememberme") != null)
                this.rememberme = this.$cookies.get("rememberme");
        }

        if (this.get_login_parameter == 'login_form_emp') {
            this.landing = false;
            this.landing_emp = true;
            this.step = 1;
        }
    },

    computed: {
        get_login_parameter() {
            let urlParams = new URLSearchParams(window.location.search);
            let myParam = urlParams.get('land_to');

            return myParam;
        },
    }
}
</script>

<style>
ul.login-tabs-nav.nav-pills {
    border: none !important;
}

ul.login-tabs-nav.nav-pills li a,
ul.login-tabs-nav.nav-pills li:last-child a {
    border: none !important;
    border-bottom: 1px solid #464d5c !important;
}

ul.login-tabs-nav.nav-pills li a.active {
    border: none !important;
    border-bottom: 1px solid #3490dc !important;
}

ul.login-tabs-nav.nav-pills li,
ul.login-tabs-nav.nav-pills li a {
    color: #fff;
}

.login-tabs-nav .nav-item:last-child a {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.login-tabs-nav .nav-item:first-child a {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}

.login_load .trz_loader {
    padding-top: 44px;
    padding-bottom: 40px;
    /* opacity: 0.5; */
    color: #000 !important;
}

.trz_loader {
    color: #222 !important;
}
</style>
